module.exports = __webpack_public_path__ + "img/hr-red-desert-decal-00.83fae8e6.png";